import { useState } from "react";
import { useLanguage } from "@/contexts/LanguageContext";
import { ScrollableTabs } from "@/components/ui/ScrollableTabs";
import * as TabsPrimitive from "@radix-ui/react-tabs";
import {
  InfoSources,
  StoneTypes,
  AssociatedCompanies,
  IPMAStations,
  Pollutants,
  TransportDistribution,
  Fuels,
  Materials,
  EnergySources,
  Residues,
} from "@/components/setup";

export const Setup = () => {
  const { t } = useLanguage();
  const [activeTab, setActiveTab] = useState("infoSources");

  const setupTabs = [
    { id: "infoSources", name: t("setup.tabs.infoSources") },
    { id: "StoneTypes", name: t("setup.tabs.tiposPedra") },
    { id: "IPMAStations", name: t("setup.tabs.estacoesIPMA") },
    { id: "Pollutants", name: t("setup.tabs.poluentes") },
    { id: "AcquiredMaterials", name: t("setup.tabs.materiaisAdquiridos") },
    {
      id: "TransportDistribution",
      name: t("setup.tabs.transporteDistribuicao"),
    },
    { id: "ElectricityConsumption", name: t("setup.tabs.consumoEletrico") },
    { id: "Fuels", name: t("setup.tabs.combustiveis") },
    { id: "Residue", name: t("setup.tabs.residuos") },
  ];

  // Dynamic component mapping
  const getComponent = (tabId: string) => {
    switch (tabId) {
      case "infoSources":
        return InfoSources;
      case "StoneTypes":
        return StoneTypes;
      case "AssociatedCompanies":
        return AssociatedCompanies;
      case "IPMAStations":
        return IPMAStations;
      case "Pollutants":
        return Pollutants;
      case "AcquiredMaterials":
        return Materials;
      case "TransportDistribution":
        return TransportDistribution;
      case "ElectricityConsumption":
        return EnergySources;
      case "Fuels":
        return Fuels;
      case "Residue":
        return Residues;
      default:
        return InfoSources;
    }
  };

  return (
    <div className="w-full">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between mb-4 sm:mb-6 gap-2">
        <h1 className="text-xl sm:text-2xl font-bold">{t("setup.title")}</h1>
      </div>

      <div className="bg-white rounded-xl shadow-sm overflow-hidden">
        {/* Description section */}
        <div className="p-6">
          <p className="text-gray-600">{t("setup.description")}</p>
        </div>{" "}
        <ScrollableTabs
          tabs={setupTabs}
          value={activeTab}
          onValueChange={setActiveTab}
        >
          {/* Create a TabsContent for each tab */}
          {setupTabs.map((tab) => {
            const TabComponent = getComponent(tab.id);
            return (
              <TabsPrimitive.Content
                key={tab.id}
                value={tab.id}
                className="p-6 focus:outline-none"
              >
                <TabComponent />
              </TabsPrimitive.Content>
            );
          })}
        </ScrollableTabs>
      </div>
    </div>
  );
};
